import IndexController from './IndexController'

export default IndexController